



























































































import { Component, Vue } from "vue-property-decorator";
import { DayPilot, DayPilotScheduler } from "daypilot-pro-vue";
import { VacationDto, AllVacationFilter, VCR, AllVCRFilter, VCRStatus } from "@/dto/payroll/VacationDTO";
import { IEmployment } from "@/dto/payroll/IEmployment";
import { WorkspaceType } from "@/dto/auth/Workspace";
import VacationRequestDetails from "@/components/payroll/vacation/VacationRequestDetails.vue";
import moment from "moment";
import Application from "@/state/Application";
import VacationService from "@/services/payroll/VacationService";
import { processError } from "@/utils/ComponentUtils";
import EmploymentService from "@/services/EmploymentService";
import { EmploymentFilter } from "@/dto/payroll/Filters";
import { CounterpartyType } from "@/constants/CounterpartyType";
import { EmploymentStatus } from "@/components/payroll/business/employments/contractors/Contractor";
import VacationRequestCreationModal from "@/components/payroll/vacation/VacationRequestCreationModal.vue";
import { EventBus } from "@/utils/EventBus";
import PortalSelect from "@/components/common/PortalSelect.vue";
import PaginationComponent from "@/components/util/PaginationComponent.vue";

@Component<VacationList>({
  components: {
    PortalSelect,
    DayPilotScheduler,
    VacationRequestDetails,
    PaginationComponent,
  },
  computed: {
    WorkspaceType() {
      return WorkspaceType;
    }
  },
  watch: {
    createMode(n) {
      if (n) {
        this.config = { ...this.config, onTimeRangeSelected: args => {
          args.control.clearSelection();
          this.checkEmptyEvent();
          const e = new DayPilot.Event({
            start: args.start,
            end: args.end,
            id: DayPilot.guid(),
            resource: args.resource,
            item: {},
            text: '',
            html: `<div class="event-content__col"></div>`,
            fontColor: '#FFFFFF',
            backColor: '#D1D1D1',
            borderRadius: this.periodMode === 0 ? '32px' : '0px',
          });
          args.control.events.add(e);
        }}
      } else {
        this.config = { ...this.config, onTimeRangeSelected: undefined };
        this.checkEmptyEvent();
      }
    },
    periodMode(n) {
      if (n === 0) {
        this.config.timeHeaders = [{groupBy: "Day", format: "d", height: 68}];
        this.config.cellWidth = 68;
        this.config.eventMinWidth = 68;
        this.config.scale = "Day";
        this.config.snapToGrid = true;
        this.config.useEventBoxes = "Always";
        this.config.startDate = (this.config.startDate as DayPilot.Date).firstDayOfMonth();
        this.config.days = (this.config.startDate as DayPilot.Date).daysInMonth();
        this.selectedYear = (this.config.startDate as DayPilot.Date).getYear();
      } else if (n === 1) {
        this.config.timeHeaders = [{groupBy: "Month", format: "MMM", height: 68}];
        this.config.cellWidth = 170;
        this.config.eventMinWidth = 0;
        this.config.scale = "Month";
        this.config.snapToGrid = false;
        this.config.useEventBoxes = "Never";
        this.config.startDate = (this.config.startDate as DayPilot.Date).firstDayOfYear();
        this.config.days = moment.duration(moment(this.startDateFilter).startOf('year').add(6, 'months').diff(moment(this.startDateFilter).startOf('year'))).as('days');
        this.selectedYear = (this.config.startDate as DayPilot.Date).getYear() + 0.1;
      } else if (n === 2) {
        this.config.timeHeaders = [{groupBy: "Month", format: "MMM", height: 68}];
        this.config.cellWidth = 170;
        this.config.eventMinWidth = 0;
        this.config.scale = "Month";
        this.config.snapToGrid = false;
        this.config.useEventBoxes = "Never";
        this.config.startDate = (this.config.startDate as DayPilot.Date).firstDayOfYear();
        this.config.days = (this.config.startDate as DayPilot.Date).daysInYear();
        this.selectedYear = (this.config.startDate as DayPilot.Date).getYear();
      }
      this.selectedMonth = (this.config.startDate as DayPilot.Date).getMonth();
      this.updateScheduler();
    }
  }
})
export default class VacationList extends Vue {

  $refs!: {
    schedulerRef: DayPilotScheduler,
  }

  private config: DayPilot.SchedulerConfig = {
    timeHeaders: [{groupBy: "Day", format: "d", height: 68}],
    scale: "Day",
    days: DayPilot.Date.today().daysInMonth(),
    startDate: DayPilot.Date.today().firstDayOfMonth(),
    resources: [],
    events: [],
    cellWidth: 68,
    durationBarVisible: false,
    cornerText: 'Days',
    // floatingEvents: false,
    rowHeaderColumnHeaderHeight: 68,
    rowHeaderWidthAutoFit: true,
    eventHeight: 68,
    eventMinWidth: 68,
    eventPadding: '22px 32px',
    eventMoveHandling: 'Disabled',
    eventResizeHandling: 'Disabled',
    eventClickHandling: 'Bubble',
    eventHoverHandling: 'Bubble',
    eventRightClickHandling: 'Disabled',
    bubble: new DayPilot.Bubble({
      hideOnClick: false,
      hideOnHover: false,
      showAfter: 0,
      hideAfter: 0.1,
      onDomAdd: (args) => {
        let component;
        if (this.isVCR(args.source.data.item)) {
          component = new VacationRequestDetails({ propsData: { vacationRequest: args.source.data.item } }).$mount();
        } else if (this.isVacationDto(args.source.data.item)) {
          component = new VacationRequestDetails({ propsData: { vacation: args.source.data.item } }).$mount();
        } else {
          component = new VacationRequestCreationModal({
              propsData: {
                employments: [this.Employments().find(item => item.id === args.source.data.resource)],
                callback: this.updateScheduler,
                periodFromCalendar: {
                  startDate: args.source.data.start.toString('yyyy-MM-dd'),
                  endDate: args.source.data.end.addDays(-1).toString('yyyy-MM-dd')
                },
              }
            }).$mount();
        }
        args.element = component.$el;
      }
    })
  };

  private vacations: Array<VacationDto> = [];
  private vacationsFilter = new AllVacationFilter();
  private vacationRequests: Array<VCR> = [];
  private vacationRequestsFilter = new AllVCRFilter({ status: VCRStatus.REQUESTED });
  private employments: Array<IEmployment> = [];
  private employmentsFilter = new EmploymentFilter({
    types: ["STAFF", "FOREIGN"],
    contractorType: CounterpartyType.PERSON,
    status: [EmploymentStatus.ACTIVE, EmploymentStatus.NEW, EmploymentStatus.PENDING_FOR_DOCUMENTS]
  });
  private years: Array<number> = [];
  private selectedMonth = moment(new Date()).month();
  private selectedYear = moment(new Date()).year();
  private totalPages = 1;
  private createMode = false;
  private periodModes = [{ title: 'Month', value: 0 }, { title: 'Half a year', value: 1 }, { title: 'Year', value: 2 }];
  private periodMode = 0;

  mounted(): void {
    EventBus.$on('changeStatusVacationRequest', () => this.updateScheduler());
    this.updateScheduler();
  }

  beforeDestroy(): void {
    EventBus.$off('changeStatusVacationRequest');
  }

  checkEmptyEvent(): void {
    if (this.config.events) {
      if (!this.isVCR(this.config.events[this.config.events.length - 1].item) && !this.isVacationDto(this.config.events[this.config.events.length - 1].item)) {
        this.config.events.pop();
      }
    }
  }

  private async updateScheduler() {
    await this.loadEmployments();
    await this.loadVacations();
    await this.loadVacationRequests();
    this.loadResources();
    this.loadEvents();
  }

  private async loadVacations() {
    Application.startLoading();
    if (this.$wss.getCurrent.type === WorkspaceType.PERSON) {
      this.vacationsFilter.employmentsId = this.employments.map(item => item.id!);
    }
    if (this.$wss.getCurrent.type === WorkspaceType.COMPANY) {
      this.vacationsFilter.employerId = this.id;
    }
    this.vacationsFilter.startDate = moment(this.startDateFilter).format('YYYY-MM-DD');
    this.vacationsFilter.endDate = moment(this.endDateFilter).format('YYYY-MM-DD');
    return VacationService.getAllVacationsByFilter(this.vacationsFilter).then(
      res => {
        this.vacations = res.data;
        Application.stopLoading();
      },
      err => processError(err, this)
    )
  }

  private async loadVacationRequests() {
    Application.startLoading();
    if (this.$wss.getCurrent.type === WorkspaceType.PERSON) {
      this.vacationRequestsFilter.employmentsId = this.employments.map(item => item.id!);
    }
    if (this.$wss.getCurrent.type === WorkspaceType.COMPANY) {
      this.vacationRequestsFilter.employerId = this.id;
    }
    this.vacationRequestsFilter.startDate = moment(this.startDateFilter).format('YYYY-MM-DD');
    this.vacationRequestsFilter.endDate = moment(this.endDateFilter).format('YYYY-MM-DD');
    return VacationService.getAllVacationRequestsByFilter(this.vacationRequestsFilter).then(
      res => {
        this.vacationRequests = res.data;
        Application.stopLoading();
      },
      err => processError(err, this)
    )
  }

  private async loadEmployments() {
    try {
      Application.startLoading();
      if (this.$wss.getCurrent.type === WorkspaceType.PERSON) {
        this.employmentsFilter.detailsId = this.id;
      } else {
        this.employmentsFilter.employerId = this.id;
      }
      const res = await EmploymentService.getPageByFilter<IEmployment>(this.employmentsFilter);
      this.employments = res.data.data;
      this.totalPages = res.data.countOfPages;
    } catch (err) {
      processError(err, this);
    } finally {
      Application.stopLoading();
    }
  }

  private loadResources() {
    if (this.$wss.getCurrent.type === WorkspaceType.PERSON) {
      this.config.resources = this.employments.map(item => {
        return { id: item.id!, name: item.employer.name };
      });
    } else {
      this.config.resources = this.employments.map(item => {
        return { id: item.id!, name: item.details.name! };
      });
    }
  }

  private loadEvents() {
    this.config.events = [...this.eventsVacations, ...this.eventsVacationRequests];
  }

  private isVCR(item: VCR | VacationDto): item is VCR {
    return 'requester' in item;
  }

  private isVacationDto(item: VCR | VacationDto): item is VacationDto {
    return 'duration' in item;
  }

  private previousPeriod() {
    if (this.periodMode === 0) {
      this.config.startDate = (this.config.startDate as DayPilot.Date).addMonths(-1);
      this.config.days = this.config.startDate.daysInMonth();
    } else if (this.periodMode === 1) {
      this.config.startDate = (this.config.startDate as DayPilot.Date).addMonths(-6);
      this.config.days = moment.duration(moment(this.startDateFilter).startOf('year').add(6, 'months').diff(moment(this.startDateFilter).startOf('year'))).as('days');
    } else {
      this.config.startDate = (this.config.startDate as DayPilot.Date).addYears(-1);
      this.config.days = this.config.startDate.daysInYear();
    }
    this.selectedMonth = this.config.startDate.getMonth();
    this.selectedYear = this.config.startDate.getYear();
    this.updateScheduler();
  };

  private nextPeriod() {
    if (this.periodMode === 0) {
      this.config.startDate = (this.config.startDate as DayPilot.Date).addMonths(1);
      this.config.days = this.config.startDate.daysInMonth();
    } else if (this.periodMode === 1) {
      this.config.startDate = (this.config.startDate as DayPilot.Date).addMonths(6);
      this.config.days = moment.duration(moment(this.startDateFilter).startOf('year').add(6, 'months').diff(moment(this.startDateFilter).startOf('year'))).as('days');
    } else {
      this.config.startDate = (this.config.startDate as DayPilot.Date).addYears(1);
      this.config.days = this.config.startDate.daysInYear();
    }
    this.selectedMonth = this.config.startDate.getMonth();
    this.selectedYear = this.config.startDate.getYear();
    this.updateScheduler();
  };

  private handleChangeRadioGroup() {
    if (this.periodMode === 0) {
      this.config.startDate = new DayPilot.Date(`${this.selectedYear}-${moment(this.selectedMonth + 1, 'M').format('MM')}-01`);
      this.config.days = this.config.startDate.daysInMonth();
    } else if (this.periodMode === 1) {
      this.config.startDate = new DayPilot.Date(`${this.selectedYear.toFixed(0)}-${moment(String(this.selectedYear).split('.')[1] === '1' ? 1 : 7, 'M').format('MM')}-01`);
      this.config.days = moment.duration(moment(this.startDateFilter).startOf('year').add(6, 'months').diff(moment(this.startDateFilter).startOf('year'))).as('days');
    } else {
      this.config.startDate = new DayPilot.Date(`${this.selectedYear}-01-01`);
      this.config.days = this.config.startDate.daysInYear();
    }
    this.updateScheduler();
  }

  private changePage(page: number) {
    this.employmentsFilter.pageNumber = page - 1;
    this.updateScheduler();
  }

  private showVacationRequestCreationModal() {
    this.$modal.show(VacationRequestCreationModal,
      {
        employments: this.employments,
        callback: this.updateScheduler,
      });
  }

  Employments(): Array<IEmployment> {
    return this.employments;
  }

  get startDateFilter(): string | undefined {
    return this.config.startDate?.toString();
  }

  get endDateFilter(): moment.Moment {
    if (this.periodMode === 0) {
      return moment(this.startDateFilter).endOf('month');
    } else if (this.periodMode === 1) {
      return moment(this.startDateFilter).add(6, 'months').endOf('month');
    } else {
      return moment(this.startDateFilter).endOf('year');
    }
  }

  get eventsVacationRequests(): Array<DayPilot.EventData> {
    return this.vacationRequests.map(item => {
      return {
        id: item.id!,
        resource: item.requester.id!,
        item,
        start: new DayPilot.Date(item.vacation.startDate),
        end: new DayPilot.Date(item.vacation.endDate).addDays(1),
        text: '',
        html: ` <div class="${this.periodMode === 0 ? 'event-content__container' : 'event-content_empty'}">
                  <div class="event-content__left-col">
                     ${this.$wss.getCurrent.type === WorkspaceType.PERSON ? item.requester.employer.name : item.requester.details.name} • ${item.vacation.startDate} - ${item.vacation.endDate} • ${item.vacation.paid ? 'Payed' : 'Not payed'} • ${item.vacation.duration}
                  </div>
                  <div class="event-content__right-col">
                    <div class="event-content__label_short">Request:&nbsp</div>
                    <div class="event-content__label">Vacation request:</div>
                    <div class="event-content__status">
                      ${item.status[0].toUpperCase() + item.status.substring(1).toLowerCase().replace('_', ' ')}
                    </div>
                  </div>
                </div>`,
        fontColor: '#FFFFFF',
        backColor: '#DDA866',
        borderRadius: this.periodMode === 0 ? '32px' : '0px',
      }
    });
  }

  get eventsVacations(): Array<DayPilot.EventData> {
    return this.vacations.map(item => {
      return {
        id: item.id!,
        resource: item.employment.id!,
        item,
        start: new DayPilot.Date(item.startDate),
        end: new DayPilot.Date(item.endDate).addDays(1),
        text: '',
        html: `<div class="${this.periodMode === 0 ? 'event-content__col' : 'event-content_empty'}">
                 ${this.$wss.getCurrent.type === WorkspaceType.PERSON ? item.employment.employer.name : item.employment.details.name} • ${item.startDate} - ${item.endDate} • ${item.paid ? 'Payed' : 'Not payed'} • ${item.duration}
               </div>`,
        fontColor: '#FFFFFF',
        backColor: new DayPilot.Date(item.endDate) < new DayPilot.Date(DayPilot.Date.today()) ? '#D1D1D1' : '#92CC8A',
        borderRadius: this.periodMode === 0 ? '32px' : '0px',
      }
    });
  }

  get checkPreviousTime(): boolean {
    return this.selectedYear === this.years[0] && this.selectedMonth === 0;
  }

  get checkNextTime(): boolean {
    return this.selectedYear === this.years[this.years.length - 1] && this.selectedMonth === 11;
  }

  get stringSelectedDate(): string {
    if (this.periodMode === 0) {
      const month: string = moment(this.selectedMonth + 1, 'M').format('MMMM');
      return month[0].toUpperCase() + month.substring(1) + ' ' + this.selectedYear.toString();
    } else if (this.periodMode === 1) {
      const wholeSelectedYear = Math.trunc(this.selectedYear);
      return String(this.selectedYear).split('.')[1] === '1' ? `${wholeSelectedYear} 1st half` : `${wholeSelectedYear} 2nd half`;
    } else {
      return this.selectedYear.toString();
    }
  }

  get getYears(): { text: string, value: number }[] {
    const startYear = 2024;
    this.years = [];
    for (let year = startYear; year <= startYear + 12; year++) {
      this.years.push(year);
    }
    if (this.periodMode === 0 || this.periodMode === 2) {
      return this.years.map((item) => {
        return { text: String(item), value: item };
      });
    } else {
      return this.years.reduce<{ text: string, value: number }[]>((accumulator, currentValue) => {
        accumulator.push({ text: `${currentValue} 1st half`, value: currentValue + 0.1 },
          { text: `${currentValue} 2nd half`, value: currentValue + 0.2 });
        return accumulator;
      }, []);
    }
  }

  get getMonths(): { text: string, value: number }[] {
    return moment.months().map((item, index) => {
      item = item[0].toUpperCase() + item.substring(1);
      return { text: item, value: index };
    });
  }

  get id(): number {
    return this.$wss.getCurrent.id;
  }

  get textTarget(): string {
    return this.$wss.getCurrent.type === WorkspaceType.PERSON ? 'request' : 'vacation';
  }

}
